import { IComponentOptions } from 'angular';
import { PlannedGraduationDropdownCtrl } from './planned-graduation-dropdown.controller';

export const PlannedGraduationDropdownComponent: IComponentOptions = {
  controller: PlannedGraduationDropdownCtrl,
  template: require('./planned-graduation-dropdown.html'),
};
